import * as angular from "angular";
import { DialogUtils } from "../../../helper/dialog.helper";
import { AdminCampaignService } from "../../../services/admin-campaign.service";
import { Campaign } from "../../../models/campaign.model";
import { ToastUtils } from "../../../helper/toast.helper";
import { Feature } from "../../../models/feature.model";
import { PermissionCheck } from "../../../shared/permission";

let AdminProspectorDialogComponent = {
    selector: "vcAdminProspectorDialog",
    templateUrl:
        "/angular/components/admin/dialogs/admin-prospector-dialog.component.html",
    bindings: {
        campaign: "=",
    },
    controller: class CampaignSubscriptionDialogController {
        // * bindings for typescript compiler *
        public campaign: Campaign;
        // ************************************
        private dialog: DialogUtils;
        private service: AdminCampaignService;
        private permissionProvider: PermissionCheck;
        private toast: ToastUtils;
        public credits: any;
        public prospectorFeature: any;
        public loading: boolean = false;
        public error: string | null;

        constructor(
            DialogUtils: DialogUtils,
            ToastUtils: ToastUtils,
            PermissionCheck: PermissionCheck,
            AdminCampaignService: AdminCampaignService
        ) {
            this.dialog = DialogUtils;
            this.toast = ToastUtils;
            this.permissionProvider = PermissionCheck;
            this.service = AdminCampaignService;
        }

        $onInit() {
            this.permissionProvider
                .getAdminFeatures(this.campaign.campaignid)
                .then((features: Feature[]) => {
                    angular.forEach(features, (feature: Feature) => {
                        if (feature.attributes.index == "PROSPECTOR_L2") {
                            this.prospectorFeature = feature.attributes;
                        }
                    });
                    this.loading = false;
                });
        }

        confirm(): void {
            this.error = null;
            if (
                this.prospectorFeature.extra.credits != 100 &&
                this.prospectorFeature.extra.credits % 10000 != 0
            ) {
                this.error = "Credits must be a multiple of 10,000";
            } else {
                if (this.prospectorFeature.extra)
                    this.service
                        .enableProspector({
                            id: this.campaign.campaignid,
                            enabled: this.prospectorFeature.owner,
                            extra: this.prospectorFeature.extra,
                        })
                        .then((response: object) => {
                            const json = response["data"];
                            if (json.success) {
                                this.toast.success(
                                    "Prospector enabled for account " +
                                        this.campaign.campaignname
                                );
                                this.dialog.hide();
                            } else {
                                this.toast.error(
                                    "Something went wrong: Prospector not enabled for campaign " +
                                        this.campaign.campaignname +
                                        ". " +
                                        (json.message ? json.message : "")
                                );
                            }
                        });
            }
        }

        dismiss(): void {
            this.dialog.cancel();
        }
    },
};

angular
    .module("admin")
    .component(
        AdminProspectorDialogComponent.selector,
        AdminProspectorDialogComponent
    );
